import { useRef, useEffect, useCallback } from 'react';
export const useAnimationFrame = (callback, active) => {
  const savedCallback = useRef();
  const interval = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  const step = useCallback(time => {
    savedCallback.current == null || savedCallback.current(time);
    if (interval.current) {
      requestAnimationFrame(step);
    }
  }, []);
  const cancel = useCallback(() => {
    if (interval.current) {
      cancelAnimationFrame(interval.current);
    }
    interval.current = undefined;
  }, []);
  useEffect(() => {
    if (active) {
      interval.current = requestAnimationFrame(step);
    }
    return () => cancel();
  }, [active, cancel, step]);
};
//# sourceMappingURL=useAnimationFrame.js.map